import React from "react";
import "./TextBox.css"
import "./Base.css"

export type TextBoxProps = 
{
    onChange : (value: string) => void;
    type : "text" | "password";
    label?: string;
    isError?: boolean;
}
export type TextBoxState = {}

export class TextBox extends React.Component<TextBoxProps, TextBoxState> {
    constructor(props: TextBoxProps) {
        super(props);
    }

    render() {
        const inputClassName = `text_box ${this.props.isError ? "error" : ""}`
        const labelClassName = `textbox_label ${this.props.isError ? "error" : ""}`

        return  <div className="form_control">
                    {this.props.label &&
                        <label className={labelClassName}>{this.props.label}</label>
                    }
                    <input 
                        type={this.props.type} 
                        className={inputClassName} 
                        onChange={e => this.props.onChange(e.currentTarget.value)} 
                        />
                </div>
    }
}